import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthModel } from '../store/auth/auth.model';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private companyID: string | null = null;
  private endpoint: string | null = null;

  constructor(private http: HttpClient, private baseService: BaseService) {}

  login(payload: any): Observable<any> {
    const { companyID, ...data } = payload;
    return this.http.post(
      `${environment.apiUrl}/kiosk/${payload.companyID}/login`,
      data
    );
  }

  logout(): Observable<any> {
    return this.baseService.post(`kiosk/logout`, null);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('accessToken');
  }

  getCompanyDetails(companyID: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/kiosk/${companyID}/details`);
  }

  getCompanyKioskSettings(companyID: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/kiosk/${companyID}/settings`);
  }
}
